import { render, staticRenderFns } from "./DropDownFile.vue?vue&type=template&id=0b90b5e0&scoped=true&"
import script from "./DropDownFile.vue?vue&type=script&lang=js&"
export * from "./DropDownFile.vue?vue&type=script&lang=js&"
import style0 from "./DropDownFile.vue?vue&type=style&index=0&id=0b90b5e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90b5e0",
  null
  
)

export default component.exports